// extracted by mini-css-extract-plugin
module.exports = {"spinner":"loading-spinner_spinner__1atKn","rotator":"loading-spinner_rotator__2ndLF"};